import { calculateProductPrice } from "./productPriceCalculator";

export default function calculateFinalPrice({
  metalRate = 0,
  purity = 999,
  inputPurity = 999,
  weight = 0,
  productCharges = {},
  taxPercentage = 0,
}) {
  const price = calculateProductPrice({
    metalRate,
    purity,
    inputPurity,
    weight,
    productDiscountPercentage: productCharges.productDiscountPercentage || 0,
    makingCharges: productCharges.makingCharges,
    makingChargesPercentage: productCharges.makingChargesPercentage,
    makingchargesType: productCharges.makingchargesType,
    makingDiscountPercentage: productCharges.makingDiscountPercentage,
    gstMakingPercentage: productCharges.gstMakingPercentage,
    taxPercentage: productCharges.taxPercentage ?? taxPercentage,
    deliveryCharges: productCharges.deliveryCharges,
    deliveryDiscountPercentage: productCharges.deliveryDiscountPercentage,
    gstDeliveryPercentage: productCharges.gstDeliveryPercentage,
    packingCharges: productCharges.packingCharges,
    packingDiscountPercentage: productCharges.packingDiscountPercentage,
    gstPackingPercentage: productCharges.gstPackingPercentage,
    hallmarkcharges:
      productCharges.hallmarkCharges ?? productCharges.hallmarkcharges,
    othercharges: productCharges.otherCharges ?? productCharges.othercharges,
  });

  return {
    ...price,
    metalPrice: price.productCost,
    discountedMetal: price.discountedProductCost,
    making: price.makingcharges,
    discountedMaking: price.discountonmaking,
    discountedDelivery: price.discountondelivery,
    discountedPacking: price.discountonpacking,
    deliveryCharges: price.deliverycharges,
    packingCharges: price.packingcharges,
    gstOnMaking: price.gstonmakingcharges,
    gstOnDelivery: price.gstondeliverycharges,
    gstOnPacking: price.gstonpackingcharges,
    taxPerc: price.taxPercentage,
    subtotal: price.finalProductPriceWithTax,
  };
}
